// App Whitelabel Config
const whitelabelConfig = {
    WHITELABEL_ID: "aflix",
    WHITELABEL_AFFILIATE_CODE: "rgaaa"
}

export default whitelabelConfig 
